import { FC } from 'react'

import { Typography } from '@/components/ui'

import { timecodeToTop } from '@/utils/timecodeToTop'

interface ITextDisplayProps {
	timecodePosition: string
	displayedTextArray: string[]
}

const TextDisplay: FC<ITextDisplayProps> = ({
	timecodePosition,
	displayedTextArray
}) => {
	if (timecodePosition === 'left') {
		return displayedTextArray?.map((string, ind) => (
			<Typography variant='text' key={ind} className='mb-4 leading-7'>
				{string}
			</Typography>
		))
	}

	if (timecodePosition === 'none') {
		return displayedTextArray?.map((string, ind) => (
			<Typography
				variant='text'
				key={ind}
				className='mb-4 leading-7 whitespace-pre-wrap'
			>
				{string.replace(/\[\d{2}:\d{2}\]\s/g, '')}
			</Typography>
		))
	}

	if (timecodePosition === 'top') {
		return (
			<Typography variant='text' className='mb-4 leading-7'>
				{timecodeToTop(displayedTextArray)}
			</Typography>
		)
	}
}

export default TextDisplay
